<template>
  <div class="box boxsize">
    <H4 class="title"> Periodo da visualizzare </H4>
    <H6 class="subtitle">
      {{ reverseDate(startweek) }} - {{ reverseDate(endweek) }}
    </H6>
    <div class="cont">
      <date-picker
        v-model="theWeek"
        value-type="YYYY-MM-DD HH:mm"
        format="DD-MM-YYYY HH:mm"
        type="week"
        confirm
        @confirm="doOK"
        :disabled-date="disabledDateCalc"
      ></date-picker>
    </div>
  </div>
</template>
<script>
import { ServiceBus } from '../../ServiceBus.js'
import { UtilityMixin } from '../../mixins/UtilityMixin.js'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/it'
export default {
  name: 'WeekChooser',
  components: {
    DatePicker,
  },
  mixins: [UtilityMixin],
  data() {
    return {
      theWeek: null,
      startweek: null,
      endweek: null,
    }
  },

  mounted() {
    const vm = this
    vm.$nextTick(function () {
      vm.theWeek = new Date()
      vm.theWeek.setHours(0)
      vm.theWeek.setMinutes(0)
      vm.theWeek.setSeconds(0)
      setTimeout(() => {
        vm.emitResult()
      }, 700)
    })
  },
  methods: {
    doOK(obj) {
      const vm = this
      vm.theWeek = new Date(obj)

      vm.emitResult()
    },

    emitResult() {
      const vm = this
      const obj = {}
      vm.calcStartEnd(vm.theWeek)
      obj.start = this.startweek
      obj.end = this.endweek
      ServiceBus.$emit('selectedWeek', obj)
    },
    calcStartEnd(newData) {
      const vm = this
      let s = vm.getWeekFirstDay(newData)
      let t = new Date(s)
      t.setDate(t.getDate(s) + 7)
      vm.startweek = vm.isoLocalDate(s).replace('T', ' ').substr(0, 16)
      vm.endweek = vm.isoLocalDate(t).replace('T', ' ').substr(0, 16)
      vm.theWeek = vm.startweek
    },
    disabledDateCalc(date) {
      const vm = this
      let newData = new Date()
      let s = vm.getWeekFirstDay(newData)
      let t = new Date(s)
      let p = new Date(s)
      t.setDate(t.getDate(s) - 8)
      p.setDate(p.getDate(s) + 6)
      return date < t || date > p
    },
  },
}
</script>
<style scoped>
.cont {
  width: 100%;
}

.cont button {
  margin-left: 15px;
}
.boxsize {
  width: 400px;
}
</style>
